<main class="main">
  <!-- Token externo expirado
  <div *ngIf="isExternalTokenExpired" class="error-container p-6">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto mb-4 text-orange-500">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
      <h2 class="text-xl font-semibold mb-2">Enlace Expirado</h2>
      <p class="text-muted-foreground mb-4">
        {{ externalTokenErrorMessage || 'El enlace de registro ha expirado o ya fue utilizado. Por favor, contacte al administrador para solicitar un nuevo enlace.' }}
      </p>
    </div>
  </div>-->

  <app-skeletor [loading]="loading" variant="create-supplier">
   <div *ngIf="showSuccessMessage">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm p-8 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto mb-4 text-green-500">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <h2 class="text-2xl font-semibold mb-2">{{formData.sendInvitation?'Invitación enviada exitosamente':'Registro Creado Exitosamente'}}</h2>
        <p class="text-muted-foreground">
          {{formData.sendInvitation?'Se ha enviado un invitación al proveedor para que complete el registro.':'El proveedor ha sido agregado a su registro correctamente.'}}
        </p>
      </div>
   </div>

    <!-- Header (solo cuando no hay mensaje de éxito) -->
    <div *ngIf="!showSuccessMessage" class="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
      </svg>

      <h2 class="text-lg font-semibold leading-none tracking-tight">Mis datos para el registro</h2>
    </div>

    <div *ngIf="!showSuccessMessage" class="space-y-6">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="flex flex-col space-y-1.5 px-6 pt-6 pb-4">
          <h3 class="font-semibold tracking-tight text-lg flex items-center gap-2">
            <i class="fa-regular fa-building"></i>
            Identificación del Proveedor
          </h3>
        </div>
        <div class="px-6">
          <div class="p-6 pt-0 space-y-4">
            <div class="grid grid-cols-2 gap-4">
              <div class="space-y-2">
                <label for="rut" class="text-sm font-medium leading-none">
                  RUT
                </label>
                <div class="relative">
                  <input 
                    pInputText 
                    id="rut" 
                    [(ngModel)]="formData.rutEmpresa"
                    (ngModelChange)="onRutChange()"
                    (blur)="onRutBlur()"
                    class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base"
                    [class.border-red-500]="showRutError"
                    [class.border-input]="!showRutError"
                    [class.border-orange-400]="siiInfoNotFound && !showRutError"
                    placeholder="Ingrese el RUT" 
                    [attr.disabled]="empresaFieldsLocked"
                    [disabled]="empresaFieldsLocked"
                  />
                  <div *ngIf="loadingEmpresaInfo" class="absolute right-3 top-1/2 -translate-y-1/2">
                    <i class="pi pi-spin pi-spinner text-gray-400"></i>
                  </div>
                </div>
                <p *ngIf="showRutError" class="text-xs text-red-500">
                  {{ rutError }}
                </p>
                <p *ngIf="siiInfoNotFound && !showRutError" class="text-xs text-orange-500 flex items-center gap-1">
                  <i class="pi pi-info-circle"></i>
                  No se encontró información en SII para este RUT
                </p>
              </div>
              <div class="space-y-2">
                <label for="companyName" class="text-sm font-medium leading-none">
                  Razón Social
                </label>
                <input 
                  pInputText 
                  id="companyName" 
                  [(ngModel)]="formData.razonSocial"
                  class="flex h-10 w-full rounded-md border border-input px-3 py-2 text-base"
                  placeholder="Ingrese la razón social"
                  [disabled]="empresaFieldsLocked"
                />
              </div>
              <div class="space-y-2 col-span-2">
                <label for="commercialName" class="text-sm font-medium leading-none">
                  Nombre Comercial
                </label>
                <input 
                  pInputText 
                  id="commercialName" 
                  [(ngModel)]="formData.nombreComercial"
                  class="flex h-10 w-full rounded-md border border-input px-3 py-2 text-base"
                  placeholder="Ingrese el nombre comercial"
                />
              </div>
              <div class="space-y-2">
                <label for="size" class="text-sm font-medium leading-none">
                  Tamaño
                </label>
                <div class="selector-ic">
                  <app-select 
                    [opciones]="availableSizes" 
                    modo="select" 
                    placeholder="Seleccione el tamaño"
                    [selectedValue]="formData.tamano" 
                    (selectionChange)="onTamanoChange($event)">
                  </app-select>
                </div>
              </div>
              <div class="space-y-2">
                <label for="economicActivity" class="text-sm font-medium leading-none">
                  Actividad Económica
                </label>
                <input 
                  pInputText 
                  id="actividadEconomica" 
                  [(ngModel)]="formData.actividadEconomica"
                  class="flex h-10 w-full rounded-md border border-input px-3 py-2 text-base"
                  placeholder="Seleccione la actividad"
                />
              </div>
              <div class="space-y-2 col-span-2">
                <label for="clasification" class="text-sm font-medium leading-none">
                  Clase
                </label>
                <div class="selector-ic">
                  <app-select [opciones]="availableClassifications" modo="select" placeholder="Seleccione una clase"
                    [selectedValue]="formData.clasificacionProveedor" (selectionChange)="onClasificacionChange($event)">
                  </app-select>
                </div>
              </div>
              <div class="space-y-2 col-span-2 flex pt-4 mr-6 items-center justify-end">
                <p-inputSwitch [(ngModel)]="formData.sendInvitation" (onChange)="onSendInvitationToggle()"
                  inputId="send-invitation">
                </p-inputSwitch>
                <label for="send-invitation" class="ml-2 text-sm font-medium leading-none cursor-pointer">
                  {{ formData.sendInvitation ? 'Enviar invitación' : 'Crear contacto manualmente' }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección de configuración de campos y documentos -->
    <div *ngIf="selectedCard && configuration && formData.sendInvitation && !showSuccessMessage" class="space-y-6">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="flex flex-col space-y-1.5 px-6 pt-6 pb-4">
          <h3 class="font-semibold tracking-tight text-lg">
            <i class="fa-light fa-table-list"></i>
            Configurar Campos de Datos
          </h3>
        </div>
        <div class="px-6">
          <div class="p-6 pt-0 space-y-4">
            <div class="grid gap-4">
              <!-- Iterar sobre las secciones de la tarjeta seleccionada -->
              <ng-container *ngFor="let section of getSelectedCardSections()">
                <!-- Obtener campos y documentos para esta sección -->
                <ng-container *ngIf="hasFieldsOrDocuments(section.sectionId)">
                  <div class="space-y-3">
                    <h4 class="font-medium text-base flex items-center gap-2">
                      {{ section.sectionName }}
                    </h4>
                    <p *ngIf="section.sectionDescription" class="text-sm text-muted-foreground">
                      {{ section.sectionDescription }}
                    </p>

                    <!-- Componente de configuración de datos y documentos -->
                    <app-data-section-settings
                      [dataRequest]="getActiveDataFieldsForSection(section.sectionId)"
                      [documentRequest]="getActiveDocumentsForSection(section.sectionId)"
                      [dataRequestStatus]="formData.cardFieldsConfig[section.sectionId] || {}"
                      [documentStatus]="documentStatus"
                      (dataRequestStatusChange)="onDataRequestStatusChange($event, section.sectionId)"
                      (documentStatusChange)="onDocumentStatusChange($event)">
                    </app-data-section-settings>
                  </div>
                </ng-container>
              </ng-container>
              
              <!-- Mensaje cuando no hay campos ni documentos configurados -->
              <div *ngIf="getSelectedCardSections().length === 0 || !hasAnyFieldsOrDocuments()" 
                  class="text-center py-4 text-muted-foreground">
                  <p>No hay campos o documentos configurados para esta tarjeta.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="formData.sendInvitation && !showSuccessMessage" class="space-y-6">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="flex flex-col space-y-1.5 px-6 pt-6 pb-4">
          <h3 class="font-semibold tracking-tight text-lg flex items-center gap-2">
            <i class="fa-slab-press fa-regular fa-envelope"></i>
            Contacto Invitación
          </h3>
        </div>
        <div class="px-6">
          <div class="p-6 pt-0 space-y-4">
            <div class="grid grid-cols-2 gap-4">
              <div class="space-y-2">
                <label for="invitationName" class="text-sm font-medium leading-none">
                  Nombre del contacto
                </label>
                <input pInputText id="invitationName" [(ngModel)]="formData.contactName"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese el nombre del contacto" />
              </div>
              <div class="space-y-2">
                <label for="invitationEmail" class="text-sm font-medium leading-none">
                  Email del contacto
                </label>
                <input pInputText type="email" id="invitationEmail" [(ngModel)]="formData.mail"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese el email del contacto" />
              </div>
            </div>
            <div class="mt-4 flex justify-end">
              <button pButton label="Enviar invitación" icon="pi pi-send" [disabled]="!isInvitationValid"
                (click)="submitInvitation()" class="bg-naranja hover:bg-orange-400 text-white font-bold py-2 px-4 rounded">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!formData.sendInvitation && !showSuccessMessage" class="space-y-6">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="flex flex-col space-y-1.5 px-6 pt-6 pb-4">
          <h3 class="font-semibold tracking-tight text-lg">
            <i class="fa-light fa-address-card"></i>
            Datos del Proveedor
          </h3>
        </div>
        <div class="px-6">
          <div class="p-6 pt-0 space-y-4">
            <div class="grid grid-cols-2 gap-4">
              <div class="space-y-2">
                <label for="address" class="text-sm font-medium leading-none">
                  Dirección
                </label>
                <input pInputText id="address" [(ngModel)]="formData.direccion"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese la dirección" />
              </div>
              <div class="space-y-2">
                <label for="region" class="text-sm font-medium leading-none">
                  Región
                </label>
                <div class="selector-ic">
                  <app-select [opciones]="availableRegions" modo="select" placeholder="Seleccione una región"
                    [selectedValue]="formData.cobertura" (selectionChange)="onCoberturaChange($event)">
                  </app-select>
                </div>
              </div>
              <div class="space-y-2">
                <label for="phone" class="text-sm font-medium leading-none">
                  Teléfono
                </label>
                <input pInputText id="phone" [(ngModel)]="formData.fono"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese el teléfono" />
              </div>
              <div class="space-y-2">
                <label for="email" class="text-sm font-medium leading-none">
                  Email
                </label>
                <input pInputText type="email" id="email" [(ngModel)]="formData.mail"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese el email" />
              </div>
              <!-- Categorías P & S (multiple) -->
              <div class="space-y-2 col-span-2">
                <label class="text-sm font-medium leading-none">
                  Productos/Servicios
                </label>
                <app-tree-selector title="Seleccionar Productos y Servicios"
                  placeholder="Seleccionar productos y servicios" [treeNodes]="productTreeNodes"
                  [selectedLabels]="formData.productosServicios" selectionMode="multiple" icon="pi pi-tag"
                  (selectionChange)="onProductsChange($event)">
                </app-tree-selector>
              </div>

              <!-- Datos Bancarios -->
              <div class="space-y-2">
                <label for="bank" class="text-sm font-medium leading-none">
                  Banco
                </label>
                <div class="selector-ic">
                  <app-select [opciones]="availableBanks" modo="select" placeholder="Seleccione un banco"
                    [selectedValue]="formData.cuentas[0].banco" (selectionChange)="onBancoChange($event)">
                  </app-select>
                </div>
              </div>
              <div class="space-y-2">
                <label for="accountType" class="text-sm font-medium leading-none">
                  Tipo Cuenta
                </label>
                <div class="selector-ic">
                  <app-select [opciones]="availableAccountTypes" modo="select" placeholder="Seleccione un tipo de cuenta"
                    [selectedValue]="formData.cuentas[0].tipo" (selectionChange)="onTipoCuentaChange($event)">
                  </app-select>
                </div>
              </div>
              <div class="space-y-2">
                <label for="accountNumber" class="text-sm font-medium leading-none">
                  Número de Cuenta
                </label>
                <input pInputText id="accountNumber" [(ngModel)]="formData.cuentas[0].numero"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base"
                  placeholder="Ingrese el número de cuenta" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!formData.sendInvitation && !showSuccessMessage" class="px-6 pt-6 flex justify-end items-center">
      <button pButton label="Agregar al Registro" icon="pi pi-check" [disabled]="!isFormValid" (click)="submitForm()" class="bg-naranja hover:bg-orange-400 text-white font-bold py-2 px-4 rounded">
      </button>
    </div>
  </app-skeletor>
</main>
